import LancamentoCaixaService from "@/services/LancamentoCaixaService";
import { router } from "@/router";
import moment from "moment";

export const actions = {
  cadastrarLancamentoCaixa: ({ commit, dispatch }) => {
    commit("setLancamentoCaixa", {
      forma_pagamento_id: "",
      forma_pagamento: "",
      valor: "",
      tipo: "",
      historico: "",
      data: moment().format('YYYY-MM-DD'),
    });
    dispatch("setModalCadastroLancamentoCaixa", true);
    commit("setFormaPagamentoSelecionadaLancamentoCaixa", {});
  },
  listarLancamentoCaixa: ({ commit }, data) => {
    commit("setOverlay", true);
    LancamentoCaixaService.listar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setLancamentosCaixa", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  salvarLancamentoCaixa: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    LancamentoCaixaService.salvar(data)
      .then((res) => {
        commit("setLancamentoCaixa", {
          forma_pagamento_id: "",
          forma_pagamento: "",
          valor: "",
          tipo: "",
          historico: "",
          data: moment().format('YYYY-MM-DD'),
        });
        commit("addLancamentoCaixa", res.data);
        commit("setOverlay", false);
        dispatch("setModalCadastroLancamentoCaixa", false)
        commit("snackbarSuccess", "Registro salvo.");
      })
      .catch((e) => {
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao salvar registro.");
      });
  },
  visualizarLancamentoCaixa: ({ commit, dispatch }, data) => {
    commit("setLancamentoCaixa", data);
    commit("setFormaPagamentoSelecionadaLancamentoCaixa", data.forma_pagamento);
    dispatch("setModalCadastroLancamentoCaixa", true);
  },
  editarLancamentoCaixa: ({ commit }, id) => {
    commit("setOverlay", true);
    LancamentoCaixaService.editar(id)
      .then((res) => {
        commit("setLancamentoCaixa", res.data);
        commit("setOverlay", false);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  atualizarLancamentoCaixa: ({ commit }, data) => {
    commit("setOverlay", true);
    LancamentoCaixaService.atualizar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarInfo", "Registro atualizado.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar registro.");
      });
  },
  impimirLancamentoCaixa: ({ commit }, id) => {
    commit("setOverlay", true);
    LancamentoCaixaService.imprimirLancamento(id)
      .then((res) => {
        commit('setModalPrint', res.data.pdf_link)
        commit("setOverlay", false);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  excluirLancamentoCaixa: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    LancamentoCaixaService.excluir(data.id)
      .then((res) => {
        dispatch("setModalExcluirLancamentoCaixa", false);
        dispatch("setModalCadastroLancamentoCaixa", false);
        commit("removeLancamentoCaixa", data);
        commit("setOverlay", false);
        commit("snackbarError", "Registro excluído.");
      })
      .catch((e) => {
        console.log(e);
        commit("snackbarError", "Erro ao excluir registro.");
        commit("setOverlay", false);
      });
  },
  setModalCadastroLancamentoCaixa: ({ commit }, status) => {
    commit("setModalCadastroLancamentoCaixa", false);
    setTimeout(() => {
      commit("setModalCadastroLancamentoCaixa", status);
    }, 100);
  },
  setModalListarLancamentoCaixa: ({ commit }, status) => {
    commit("setModalListarLancamentoCaixa", false);
    setTimeout(() => {
      commit("setModalListarLancamentoCaixa", status);
    }, 100);
  },
  setModalExcluirLancamentoCaixa: ({ commit }, status) => {
    commit("setModalExcluirLancamentoCaixa", false);
    setTimeout(() => {
      commit("setModalExcluirLancamentoCaixa", status);
    }, 100);
  },
  setModalRelatorioFechamentoCaixa: ({ commit }, status) => {
    commit("setModalRelatorioFechamentoCaixa", false);
    setTimeout(() => {
      commit("setModalRelatorioFechamentoCaixa", status);
    }, 100);
  },
};

export default {};
